import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SocketConnectionState from "./Helpers/socketConnectionState";
import { getDomain } from "../../Utilities/utils";
import { PRODUCT_LIST_ENDPOINT } from "../apiConfig";
import Swal from "sweetalert2";
import Axios from "axios";
import CryptoJS from "crypto-js";
import { getLocalData } from "../../Utilities/Common/source";
import axiosInstance from "../../Utilities/djangoAxiosInstance";
import SignIn from "../../AcuvisorCustomerApp/components/userAuth/SignIn";
import { useAuth } from "../../AcuvisorCustomerApp/context/useAuth";

const useListOfProducts = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useLocation();
  const { requestBody } = state ?? {}; // requestBody from QuickQuotePage

  const [data, setData] = useState([]);
  const [productList, setProductList] = useState([]);
  const [responseId, setResponseId] = useState(null);
  const [dialogState, setDialogState] = useState(false);

  const [socketConnectionState, setSocketConnectionState] = useState(
    SocketConnectionState.CONNECTING,
  );
  const [openSignIn, setOpenSignIn] = useState(false);
  const { user } = useAuth();
  const localSource = getLocalData("source");
  console.log("PLP localSource: ", localSource);

  useEffect(() => {
    let socket = null;
    let isMounted = true; // Flag to check if the component is still mounted

    const domain = getDomain()
      .replace("https://", "wss://")
      .replace("http://", "ws://");

    const websocketURL = `${domain}${PRODUCT_LIST_ENDPOINT}`;

    const connectWebSocket = () => {
      socket = new WebSocket(websocketURL);

      socket.onopen = () => {
        console.log("WebSocket connection opened.");
        if (isMounted) {
          setSocketConnectionState(SocketConnectionState.CONNECTED);
        }
        // Check if it's the first visit
        if (state && state.isFirstVisit) {
          socket.send(requestBody);
          // After performing the action, you can update the flag to indicate it's no longer the first visit
          // const updatedState = { ...state, isFirstVisit: false };
          // navigate(location.pathname, { state: updatedState });
        } else {
          console.log("responseId: ", state.id);
          console.log("worked", state.isFirstVisit);
          socket.send(JSON.stringify({ id: state.id, source: localSource }));
        }
      };
      socket.onmessage = (event) => {
        const response = JSON.parse(event.data);
        console.log("response: ", response);
        if (Object.keys(response).length > 0 && isMounted) {
          // If response is an array that means reponse is a product
          if (Array.isArray(response)) {
            setData((prev) => [...prev, ...response]);
            setProductList((prev) => [...prev, ...response]);
          } else {
            // otherwise response is an id
            setResponseId(response?.id);
            const updatedState = {
              ...state,
              id: !response?.id ? state.id : response?.id,
              isFirstVisit: false,
            };
            navigate(location.pathname, { state: updatedState });
          }
        }
      };

      socket.onclose = () => {
        console.log("WebSocket connection closed.");
        if (isMounted) {
          setSocketConnectionState(SocketConnectionState.DISCONNECTED);
        }
      };

      socket.onerror = (error) => {
        console.error("WebSocket error:", error);
        if (isMounted) {
          setSocketConnectionState(SocketConnectionState.ERROR);
          Swal.fire({
            icon: "error",
            text: "Something went wrong...",
            position: "center",
          }).then((result) => {
            if (result.isConfirmed) {
              connectWebSocket();
            }
          });
        }
      };
    };

    // Connect WebSocket when the component mounts
    connectWebSocket();

    // Cleanup function to close the WebSocket and avoid memory leaks
    return () => {
      isMounted = false; // Set isMounted to false to prevent state updates after unmounting
      if (socket) {
        socket.close();
      }
    };
  }, []);

  const goBack = () => {
    navigate(-1);
  };

  const handleSearch = (val) => {
    console.log("search val", val.target.value, data);
    let incomingVal = val.target.value;
    let filterData = data.filter((item) => {
      if (incomingVal === "") {
        return item;
      } else if (
        item.product_name.toLowerCase() === incomingVal.toLowerCase()
      ) {
        return item;
      }
    });
    console.log("kkk", filterData.length);
    if (filterData.length > 0) {
      setProductList(filterData);
    } else {
      setProductList([]);
    }
  };

  const sortByPremium = (val) => {
    console.log("sss", val);
    if (val === "LOW") {
      let filterData = data.sort((a, b) => {
        return parseFloat(a.premium) - parseFloat(b.premium);
      });
      setProductList(filterData);
      console.log("low sort", filterData);
    } else {
      let filterData = data.sort((a, b) => {
        return parseFloat(b.premium) - parseFloat(a.premium);
      });
      setProductList(filterData);
    }
  };

  const handleSort = () => {
    console.log("sort");
    setDialogState(true);
  };

  const handleCloseSort = () => {
    setDialogState(false);
  };

  console.log("product list check", productList);
  if (
    socketConnectionState === SocketConnectionState.DISCONNECTED &&
    productList.length === 0 &&
    !state?.id
  ) {
    Swal.fire({
      icon: "error",
      text: `Didn't find anything best for you, please re-enter details`,
      // text: `Please click on 'OK' button to refill the Quick Quote`,
      position: "center",
    }).then((result) => {
      if (result.isConfirmed) {
        goBack();
      }
    });
  }

  const getPolicy = (index) => {
    let passData = [];
    console.log("index", index);
    if (!user && localSource === "b2c") {
      // handle user login
      Swal.fire({
        imageUrl: "/images/b2c/SignIn.png",
        imageWidth: 75,
        imageHeight: 75,
        html: `
        <p style="font-size: 32px; color: #555; margin: 0;">
          <strong>You are not verified.</strong><br>
          <span style="font-size: 18px; color: #777;">Please <span style="">Sign In</span> to continue.</span>
        </p>
      `,
        position: "center",
        confirmButtonText: "Sign In",
      }).then((result) => {
        if (result.isConfirmed) {
          // navigate("/signin")
          setOpenSignIn(true);
        }
      });
      return;
    }
    productList.map((item, itemIndex) => {
      if (itemIndex === index) {
        console.log("ITEM", item);
        console.log("ref", item.product_ref);
        let encryptedAcuvisor_product_id = encodeURIComponent(
          CryptoJS.AES.encrypt(
            JSON.stringify(item.Acuvisor_product_id),
            "secret key @124",
          ).toString(),
        );
        let encryptedProduct_ref = encodeURIComponent(
          CryptoJS.AES.encrypt(
            JSON.stringify(item.product_ref),
            "secret key @123",
          ).toString(),
        );

        const domain = getDomain();
        console.log("item: ", item);

        axiosInstance
          .post(
            `api/health/quickquote-details/`, // TODO:
            JSON.stringify(item),
            {
              params: {
                source: localSource,
              },
            },
          )
          .then((response) => {
            console.log("response.status", response.status);
            if (response.status === 200) {
              console.log("response from django", response);

              let encryptedDataId = encodeURIComponent(
                CryptoJS.AES.encrypt(
                  JSON.stringify(response.data.id),
                  "secret key @124",
                ).toString(),
              );
              console.log("encry Respnse Daat Id", encryptedDataId);

              let path = `/health-insurance/product-detail/${encryptedProduct_ref}*${encryptedDataId}*${encryptedAcuvisor_product_id}`;

              navigate(path, { state: item });
            }
          })
          .catch((error) => {
            console.error("Error:", error);

            if (error.response) {
              // The request was made and the server responded with a non-2xx status code
              console.error("Error Response:", error.response);

              if (error.response.status === 401) {
                // Handle 401 Unauthorized
                var errorMessage =
                  "You are not verified. Please Sign In to continue.";
              } else {
                // Handle other non-2xx status codes
                var errorMessage = "An error occurred. Please try again later";
              }
              Swal.fire({
                icon: "error",
                text: errorMessage,
                position: "center",
              }).then((result) => {
                if (result.isConfirmed) {
                  // navigate("/signin")
                  setOpenSignIn(true);
                }
              });
            } else if (error.request) {
              // The request was made but no response was received
              console.error("No response received:", error.request);
              alert(
                "No response received. Please check your internet connection.",
              );
            } else {
              // Something happened in setting up the request that triggered an error
              console.error("Request setup error:", error.message);
              alert("Error setting up the request. Please try again later.");
            }
          });
      }
    });
  };

  return {
    socketConnectionState,
    sortByPremium,
    handleSort,
    handleSearch,
    handleCloseSort,
    dialogState,
    productList,
    getPolicy,
    goBack,
    openSignIn,
  };
};

export default useListOfProducts;
